// extracted by css-extract-rspack-plugin
export default {"dropdownLoadingContent":"_b6460683"};